export const formatNumber = (value: string) => {
  if (!value) return "";
  return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const unformatNumber = (value: string) => {
  return value.replace(/,/g, "");
};
